"use client";

import { Command, CommandList } from "@/components/ui/command";
import { SearchResultsList } from "./SearchResultsList";
import { UseMyLocationButton } from "./UseMyLocationButton";
import { SelectedLocationDisplay } from "./SelectedLocationDisplay";
import { SuggestedCitiesList } from "./SuggestedCitiesList";
import type { LocationSelectorContentProps } from "./types";

export function LocationSelectorContent({
  searchQuery,
  placeSuggestions,
  isSearching,
  isDebouncing,
  effectiveCurrentArea,
  effectiveCustomLocation,
  currentCountryOptions,
  isGeoSupported,
  isGeoLoading,
  isReverseGeocoding,
  geoError,
  onAreaSelect,
  onPlaceSelect,
  onUseMyLocation,
}: LocationSelectorContentProps) {
  const showSearchResults = searchQuery.length >= 2;

  return (
    <Command shouldFilter={false}>
      <CommandList className="max-h-none">
        {showSearchResults ? (
          <SearchResultsList
            suggestions={placeSuggestions}
            isSearching={isSearching}
            isDebouncing={isDebouncing}
            onSelect={onPlaceSelect}
          />
        ) : (
          <>
            {isGeoSupported && (
              <UseMyLocationButton
                isLoading={isGeoLoading || isReverseGeocoding}
                error={geoError}
                onSelect={onUseMyLocation}
              />
            )}
            <SelectedLocationDisplay
              customLocation={effectiveCustomLocation}
              currentArea={effectiveCurrentArea}
              countryOptions={currentCountryOptions}
            />
            <SuggestedCitiesList
              options={currentCountryOptions}
              currentArea={effectiveCurrentArea}
              hasCustomLocation={effectiveCustomLocation != null}
              onSelect={onAreaSelect}
            />
          </>
        )}
      </CommandList>
    </Command>
  );
}
